module.exports = __webpack_public_path__ + "img/km.a79e39ad.svg";